import apiRequest from './client';

export const listMyBanks = () => apiRequest('/sub-supervisors/banks/');
